import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 🧾 Reporte X (cortes X de caja por rango de fechas)
 *
 * Backend esperado: branchId, dateFrom, dateTo
 */
export const reportXFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
